<script setup lang="ts">
const MAX_WORDS = 28;

interface Props {
  maxWords?: number;
}

const props = withDefaults(defineProps<Props>(), {
  maxWords: MAX_WORDS,
});

const contentRef = useTemplateRef('content');

const shortText = ref('');
const isClipped = ref(true);

const onMoreClick = () => {
  isClipped.value = false;
};

const init = () => {
  if (!contentRef.value) return;

  const fullText = contentRef.value.innerText;
  const words = fullText.split(' ');

  const extraWordCount = props.maxWords / 3; // Количество лишних слов, при котором имеет смысл обрезать текст

  isClipped.value = props.maxWords - words.length + extraWordCount <= 0;

  if (isClipped.value) {
    shortText.value = words.slice(0, props.maxWords).join(' ');
  }
};

onMounted(() => {
  init();
});

watch(() => props.maxWords, () => {
  if (!isClipped.value) return;

  init();
});
</script>

<template>
  <span class="text-clip">
    <span
      v-show="!isClipped"
      ref="content"
      class="text-clip__content"
    >
      <slot></slot>
    </span>

    <template v-if="isClipped">
      <span class="text-clip__short">
        {{ shortText }}
      </span>

      <button class="text-clip__button" type="button" @click="onMoreClick">Читать далее</button>
    </template>
  </span>
</template>

<style lang="scss" scoped>
.text-clip {
  position: relative;

  &__button {
    @include underline;

    font-size: inherit;
    line-height: inherit;

    color: $color-neutral-50;

    text-align: left;

    &:hover {
      @media (hover: hover) {
        text-decoration: none;
      }
    }
  }

  &__short {
    &:after {
      content: '…';
    }
  }
}
</style>
